import {
  addNewProduct,
  updateProduct,
  getAllProducts,
  addProductBenefit,
  getAllProductBenefits,
  getProductAdditionalInfo,
  getAllProductEligibility,
  getAllProductPremium,
  deleteProductBenefit,
  changeProductStatus,
  GetProductListParams,
  deleteproductpremium,
} from "services/insuranceService";

import {
  fetchProducts,
  fetchBenefits,
  fetchAdditionalInfo,
  fetchEligibility,
  fetchPremium,
  setPagination,
  setLoader,
  successMsg,
  errorMsg,
} from "./reducer";

import { toast } from "react-toastify";  

export const fetchProductsThunk =
  (params: GetProductListParams) => async (dispatch: any) => {
    dispatch(setLoader(true));

    try {
      const response = await getAllProducts(params);

      console.log("API RESPONSE:", response);  

      if (response?.success) {
        const list = response?.data?.product || [];  
        const pagination = response?.data?.pagination || {};

        dispatch(fetchProducts({ products: list, pagination }));
        dispatch(setPagination(pagination));
      } else {
        dispatch(errorMsg({ message: response?.message, id: Date.now() }));
        toast.error(response?.message || "Failed to load products");
      }
    } catch (error: any) {
      dispatch(errorMsg({ message: error?.message, id: Date.now() }));
      toast.error(error?.message || "Failed to load products");
    } finally {
      dispatch(setLoader(false));
    }
  };

export const addProductThunk =
  (data: any) => async (dispatch: any) => {
    dispatch(setLoader(true));
    try {
      const response = await addNewProduct(data);

      if (response?.success) {
        dispatch(successMsg({ message: response?.message, id: Date.now() }));
        toast.success(response?.message || "Product added successfully");
      } else {
        dispatch(errorMsg({ message: response?.message, id: Date.now() }));
        toast.error(response?.message || "Failed to add product");
      }
    } catch (error: any) {
      dispatch(errorMsg({ message: error?.message, id: Date.now() }));
      toast.error(error?.message || "Something went wrong");
    } finally {
      dispatch(setLoader(false));
    }
  };

export const updateProductThunk =
  (id: number, data: any) => async (dispatch: any) => {
    dispatch(setLoader(true));
    try {
      const response = await updateProduct(id, data);

      if (response?.success) {
        dispatch(successMsg({ message: response?.message, id: Date.now() }));
        toast.success(response?.message || "Product updated");
      } else {
        dispatch(errorMsg({ message: response?.message, id: Date.now() }));
        toast.error(response?.message || "Failed to update product");
      }
    } catch (error: any) {
      dispatch(errorMsg({ message: error?.message, id: Date.now() }));
      toast.error(error?.message || "Failed to update product");
    } finally {
      dispatch(setLoader(false));
    }
  };

export const changeProductStatusThunk =
  (id: number, status: string) => async (dispatch: any) => {
    try {
      const payload = { status }; // body

      const response = await changeProductStatus(id, payload); // pass both

      if (response?.data?.success) {
        dispatch(successMsg({ message: response?.data?.message, id: Date.now() }));
        toast.success(response?.data?.message || "Status updated");
      } else {
        dispatch(errorMsg({ message: response?.data?.message, id: Date.now() }));
        toast.success(response?.data?.message || "Status Changed successfully");
      }
    } catch (error: any) {
      dispatch(errorMsg({ message: error?.message, id: Date.now() }));
      toast.error(error?.message || "Failed to change status");
    }
  };


export const fetchBenefitsThunk =
  (product_id: number) => async (dispatch: any) => {
    try {
      const res = await getAllProductBenefits(product_id);

      if (res?.success) {
        dispatch(fetchBenefits(res?.data || []));
      }
    } catch {
      dispatch(errorMsg({ message: "Failed to fetch benefits", id: Date.now() }));
      toast.error("Failed to fetch benefits");
    }
  };

export const addBenefitThunk =
  (data: any) => async (dispatch: any) => {
    try {
      const res = await addProductBenefit(data);

      if (res?.success) {
        dispatch(successMsg({ message: res?.message, id: Date.now() }));
        toast.success(res?.message || "Benefit added");
      } else {
        dispatch(errorMsg({ message: res?.message, id: Date.now() }));
        toast.error(res?.message || "Failed to add benefit");
      }
    } catch {
      dispatch(errorMsg({ message: "Error adding benefit", id: Date.now() }));
      toast.error("Error adding benefit");
    }
  };

export const deleteBenefitThunk =
  (id: number) => async (dispatch: any) => {
    try {
      const res = await deleteProductBenefit(id);

      if (res?.success) {
        dispatch(successMsg({ message: res?.message, id: Date.now() }));
        toast.success(res?.message || "Deleted successfully");
      } else {
        dispatch(errorMsg({ message: res?.message, id: Date.now() }));
        toast.error(res?.message || "Failed to delete");
      }
    } catch {
      dispatch(errorMsg({ message: "Error deleting", id: Date.now() }));
      toast.error("Error deleting");
    }
  };

  export const deletePremiumThunk =
  (id: number) => async (dispatch: any) => {
    try {
      const res = await deleteproductpremium(id);

      if (res?.success) {
        dispatch(successMsg({ message: res?.message, id: Date.now() }));
        toast.success(res?.message || "Deleted successfully");
      } else {
        dispatch(errorMsg({ message: res?.message, id: Date.now() }));
        toast.error(res?.message || "Failed to delete");
      }
    } catch {
      dispatch(errorMsg({ message: "Error deleting", id: Date.now() }));
      toast.error("Error deleting");
    }
  };

export const fetchAdditionalInfoThunk =
  (product_id: number) => async (dispatch: any) => {
    try {
      const res = await getProductAdditionalInfo(product_id);
      dispatch(fetchAdditionalInfo(res?.data || {}));
    } catch {
      toast.error("Failed to load additional info");
    }
  };

export const fetchEligibilityThunk =
  (product_id: number) => async (dispatch: any) => {
    try {
      const res = await getAllProductEligibility(product_id);
      dispatch(fetchEligibility(res?.data || []));
    } catch {
      toast.error("Failed to load eligibility");
    }
  };

export const fetchPremiumThunk =
  (product_id: number) => async (dispatch: any) => {
    try {
      const res = await getAllProductPremium(product_id);
      dispatch(fetchPremium(res?.data || {}));
    } catch {
      toast.error("Failed to load premium");
    }
  };
